<iframe
  #iframe
  *ngIf="link"
  class="w-full h-full"
  [src]="link"
  frameborder="0"
></iframe>
